// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-module--root--11CHY","links":"Footer-module--links--3MFss"};